import { render } from "./courseServiceInfo.vue?vue&type=template&id=61c865c7&scoped=true"
import script from "./courseServiceInfo.vue?vue&type=script&lang=js"
export * from "./courseServiceInfo.vue?vue&type=script&lang=js"

import "./courseServiceInfo.vue?vue&type=style&index=0&id=61c865c7&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c865c7"]])

export default __exports__